<div class="h-100">
	<app-non-logged-in-user-header></app-non-logged-in-user-header>
	<div class="p-4 w-100 body overflow-auto">
		<p-card>
			<p-messages [value]="[msg]" [enableService]="false" [closable]="false"></p-messages>
			<app-contact-us [isImportedInAnotherPage]="true" (submitChanges)="submitChanges()" [userId]="userId" [options]="{hideTitle: true, forced: true}"></app-contact-us>
		</p-card>
	</div>
</div>